import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const notificationServiceApi = createApi({
    reducerPath: 'notificationServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['Notification'],
    endpoints: (builder) => ({


        getAllNotification: builder.query({
            query: () => `/v1/notification`,
            providesTags: ['Notification'],
        }),
     
        createNotification: builder.mutation({
            query: (formData) => ({
                url: `/v1/notification/sendNotification`,
                method: 'POST',
                body: formData,
                headers: {
                    'authorization': token,
                   
                },
            }),
            invalidatesTags: ['Notification'],
        }),

 
    }),
});

export const {useCreateNotificationMutation, useGetAllNotificationQuery} = notificationServiceApi;